import { render, staticRenderFns } from "./TotalRegistered.vue?vue&type=template&id=47373424&scoped=true&"
import script from "./TotalRegistered.vue?vue&type=script&lang=js&"
export * from "./TotalRegistered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47373424",
  null
  
)

export default component.exports